import './dettaglio-rubriche.scss';

/**
 * version    1.0
 * class      <type> (DettaglioRubriche)
 * classdesc
 */
export class DettaglioRubriche {}
